define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/portal/favorites/crm/servicerequesttypes/',
    url: function() {
      var u = this.urlRoot;
      if(this.id) {
        u+= this.id
      }
      return u;
    }
  });
})
